import React from "react";
import { User } from "../../types";
import { Card, Stack, Typography } from '@material-ui/core';

import timeLeft from '../../utils/timeLeft';


interface Props {
  user: User;
}

const UserInAppProducts: React.FC<Props> = ({ user }) => {
  if (!user.appFeatures) {
    return null;
  }

  const keys = Object.keys(user.appFeatures);
  const features = user.appFeatures;

  return (
    <Stack direction="column">
      {keys.map(key => {
        const appFeature = features[ key ];
        return (
          <Card sx={{ mb: 2, p: 2 }} variant="outlined" key={key}>
            <Typography>
              {key}
            </Typography>
            <Typography>
              Expires {timeLeft(appFeature.expire.toDate())}
            </Typography>
          </Card>
        )
      })}
    </Stack>
  );
};

export default UserInAppProducts;